import { render, staticRenderFns } from "./productsSection.vue?vue&type=template&id=b28d899c&"
import script from "./productsSection.vue?vue&type=script&lang=js&"
export * from "./productsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports